import clsx from "clsx";
import { ReactNode } from "react";

type InstructionsProps = {
  children: ReactNode;
  image?: string;
  onImageClick?: () => void;
  alt?: string;
};

const Instructions = ({
  image,
  onImageClick,
  alt,
  children,
}: InstructionsProps) => (
  <div
    className={clsx(
      "flex items-center my-[1.6rem] gap-medium",
      onImageClick && "cursor-pointer",
    )}
  >
    {image && (
      <button
        className={clsx(
          "w-[4.5rem] bg-none border-0 m-0 p-0",
          onImageClick && "cursor-pointer",
        )}
        type="button"
        onClick={onImageClick}
      >
        <img className="w-full" src={image} alt={alt} />
      </button>
    )}
    <p className="flex-1 m-0 text-ui">{children}</p>
  </div>
);

export { InstructionsProps, Instructions };
